<template>
  <div class="contact">
    <div v-if="!edition_state">
      <div class="row flexed">
        <strong style="align-self: center;">{{ contact.decoded_civility}} {{ contact.first_name }} {{ contact.last_name }} </strong><br>
        <button class="btn btn-success" style="margin-left:auto;margin-right:10px;" @click="start_edition" :disabled="is_fetching"> Modifier</button>
        <button class="btn " @click="$emit('delete-contact', {lead_id:lead_id, contact_id:contact.id, data:contact})">Supprimer</button>
      </div>
      <div class="row">
        <span v-if="contact.position">{{contact.position}}<br></span>
        <span v-if="contact.email">
          Email : {{ contact.email}}<br>
        </span>
        <span v-if="contact.phone">
          Tél. : {{ contact.phone}}<span v-if="contact.mobile_phone"> - </span>
        </span>
        <span v-if="contact.mobile_phone">
          Mobile : {{ contact.mobile_phone}}
        </span>
      </div>
    </div>
    <div v-else>
      <resource-form v-if="form" :model="form.model" :schema="form.schema" :triggers="form.triggers" @submit="submit_edition"></resource-form>
      <button class="btn" @click="stop_edition">Annuler</button>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import ResourceForm from "components/Forms/ResourceForm"
export default {
  name:"Contact",
  props:["contact","lead_id"],
  components:{
    ResourceForm
  },
  data () {
    return {
      edition_state:false
    }
  },

  computed:{
    ...mapGetters("crm", ["is_fetching", "contacts", "page_of_leads", "forms","is_any_errors"]),
    form() {
      var exists = _.find(this.forms, ctc => ctc.lead_id == this.lead_id && ctc.contact_id == this.contact.id && !ctc.flag)
      if (exists !== undefined)
        return exists.form
      return null
    }
  },

  methods:{
    ...mapActions("crm", ["fetch_contact_edition_form", "update_contact_of_lead","set_fetching_state","fetch_all_contacts","reset_errors","fetch_a_lead","reset_form"]),

    start_edition(){
      this.edition_state = true
      this.set_fetching_state(true)
      this.reset_form(_.filter(this.forms, f => !(f.contact_id == this.contact.id)))
      this.fetch_contact_edition_form({lead_id:this.lead_id, contact_id:this.contact.id})
          .then(() => this.set_fetching_state(false))
    },

    submit_edition(event) {
      this.reset_errors()

      var exists = _.find(this.forms, ctc => ctc.lead_id == this.lead_id && !ctc.flag)
      if (exists !== undefined)
        {
          this.update_contact_of_lead({lead_id:exists.lead_id, contact_id:exists.contact_id, body:event.data})
              .then(() =>
                  {
                    if (!this.is_any_errors)
                      this.stop_edition()
                  })
              .then(() => {
                this.set_fetching_state(true)
                this.fetch_a_lead(exists.lead_id)
                    .then(() => {
                      this.reset_form(_.filter(this.forms, f => !(f.contact_id == this.contact.id)))
                      this.set_fetching_state(false)
                    })
              })
        }
    },


    stop_edition(){
      this.edition_state = false
    },

  }
}
</script>
<style scoped>

.flexed {
  display: flex;
}

.contact {
  /*padding:20px;*/
  margin-bottom:15px;
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/Contact.vue